import React from "react";
import "./Who_We_Are.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Who_We_Are = () => {
  const data = [
    {
      tittle: "Architectural Design",
      subtext: "Dream it, we’ll design it!",
      descn:
        "From big picture layouts to the tiniest details, our architectural magic brings your ideas to life with creativity and precision!",
      img: "/assets/images/home/who_we_are/img1.png",
    },
    {
      tittle: "Interior Design & Planning",
      subtext: "Make your space shine!",
      descn:
        "Our team creates inviting, beautiful interiors that reflect your style & make every room a favorite place to be.",
      img: "/assets/images/home/who_we_are/img2.png",
    },
    {
      tittle: "Consulting Services",
      subtext: "Consider us your design whisperers!",
      descn:
        "We provide expert advice to help your project sparkle with creativity, efficiency, and spot-on solutions.",
      img: "/assets/images/home/who_we_are/img3.png",
    },
    {
      tittle: "Project Management",
      subtext: "Dream it, we’ll design it!",
      descn:
        "From big picture layouts to the tiniest details, our architectural magic brings your ideas to life with creativity and precision!",
      img: "/assets/images/home/who_we_are/img4.png",
    },
  ];

  return (
    <section className="Who_We_Are">
      <div className="container">
        <div className="main_content_div">

          <div className="row">
            <div className="col-md-8 col-sm-7">
              <Common_Title
                pageTitle="WHO WE ARE"
                boxText="Experience"
                subText="the Art of Interior Design"
                darkText="Tech Interiors and Designers – Best Interior
Designers in Pune"
                simpleText="Welcome to Tech Interiors and Designers, a trusted name in interior design and
decorating services in Pune with over 20 years of expertise. From cozy 1BHK apartments
to luxurious bungalows and multi-storeyed buildings, we transform spaces into elegant,
functional, and personalized homes and workplaces."
              />
            </div>
            <div className="col-md-4 col-sm-5">
              <div className="img_holder">
                <img src="/assets/images/home/who_we_are/Who_We_Are_img.png" alt="" className="Who_We_Are_img" />
              </div>
            </div>
          </div>

          {/* <Common_Title
            simpleText="With a team of skilled artisans, carpenters, painters, and civil experts, we bring your
                vision to life while ensuring top-notch quality, timely delivery, and complete transparency."
          /> */}

          <div className="cards_holder">
            <div className="row">
              {data?.map((item) => {
                return (
                  <div className="col-xl-3 col-lg-4 col-sm-6 mb-sm-4 col-6  mb-2">
                    <div className="white_card">
                      <div className="right_corner_img_div">
                        <img src={item?.img} className="corner_img" />
                      </div>
                      <p className="title_text">{item?.tittle}</p>
                      <p className="sub_text">{item?.subtext}</p>
                      <p className="descn_text">{item?.descn}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Who_We_Are;
